<template>
  <nav class="hidden lg:flex justify-end w-full h-full mr-4">
    <a
      v-for="item in MenuPublicInstance"
      :key="item.name"
      :href="item.href"
      class="mx-2 px-1 relative items-center flex text-sm font-medium font-sans subpixel-antialiased tracking-normal no-underline focus-visible:ring-primary-400 focus-visible:ring-opacity-50 focus-visible:ring-primary-400 focus-visible:ring-3 focus-visible:outline-0 focus-visible:outline-none"
      :class="
        item.selected
          ? 'text-primary-900'
          : 'text-gray-700 hover:text-primary-900 transition ease-in-out duration-300 group'
      "
      :aria-label="t(item.name)"
    >
      {{ t(item.name) }}
      <span
        class="absolute inset-x-0 bottom-0 h-1 bg-primary-900"
        :class="
          item.selected
            ? ''
            : 'opacity-0 group-hover:opacity-100 transition ease-in-out duration-300'
        "
      />
    </a>
  </nav>
</template>

<script setup lang="ts">
import { useMenuPublic } from '../composables/useMenuPublic'
const { MenuPublicInstance } = await useMenuPublic()
</script>
